import React, { useContext, useState } from 'react';

import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import SourceFilter from 'common/subdomain/admin/AdminQueue/SourceFilters/SourceFilter';
import { useIntercomSourceFilter } from 'common/subdomain/admin/AdminQueue/SourceFilters/useIntercomSourceFilter';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';

import SourceFiltersModal from './SourceFiltersModal';

import type { Integration } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';

type Props = {
  onClose: () => void;
  integration: Integration;
  enableIntegrationSync: (integration: Integration) => void;
};

const IntercomSourceFiltersModal = ({ onClose, integration, enableIntegrationSync }: Props) => {
  const company = useContext(CompanyContext);
  const { intercom } = company;
  const [selectedIDs, setSelectedIDs] = useState<string[] | null>(
    intercom?.autopilotTeamInboxIDs ?? null
  );
  const { loading, error, options, selectedOptions } = useIntercomSourceFilter(selectedIDs);

  const [saveError, setSaveError] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const onSubmit = async () => {
    setSaving(true);
    setSaveError(false);

    const response = await AJAX.post('/api/intercom/setTeamInboxes', { teamIDs: selectedIDs });
    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
    });

    if (error) {
      setSaveError(true);
    } else {
      enableIntegrationSync(integration);
      onClose();
    }
    setSaving(false);
  };

  return (
    <SourceFiltersModal
      saving={saving}
      onClose={onClose}
      integration={integration}
      enableIntegrationSync={enableIntegrationSync}
      onSubmit={onSubmit}
      sourceFilter={
        <SourceFilter
          loading={loading}
          error={error}
          options={options}
          selectedOptions={selectedOptions}
          filterLabel="Filter by team inbox"
          onChange={setSelectedIDs}
          saveError={saveError}
        />
      }
    />
  );
};

export default IntercomSourceFiltersModal;
